import { authHttp } from 'utils/http';

export const fetchAllReports = () => {
    return authHttp({
        method: 'get',
        url: '/segments-reports'
    }).then((res) => res.data);
};

/* [
    'name' => 'test',
    'segments' => [
        [
            'name' => 'test',
            'asins' => [
                'ABCDEFGHIJ'
            ]
        ]
    ]
] */
export const createReport = (data) => {
    return authHttp({
        data,
        method: 'post',
        url: '/segments-reports'
    }).then((res) => res.data.data);
};

export const fetchReport = (id) => {
    return authHttp({
        method: 'get',
        url: `/segments-reports/${id}`
    }).then((res) => res.data.data);
};

export const updateReportName = (id, name) => {
    return authHttp({
        data: { name },
        method: 'patch',
        url: `/segments-reports/${id}`
    }).then((res) => res.data);
};

export const deleteReport = (id) => {
    return authHttp({
        method: 'delete',
        url: `/segments-reports/${id}`
    }).then((res) => res.data.data);
};

export const addSegment = (segmentsReportId, data) => {
    return authHttp({
        data: {
            ...data,
            segmentsReportId
        },
        method: 'post',
        url: '/segments'
    }).then((res) => res.data.data);
};

export const updateSegment = (id, data) => {
    return authHttp({
        data,
        method: 'patch',
        url: `/segments/${id}`
    }).then((res) => res.data.data);
};

export const deleteSegment = (id) => {
    return authHttp({
        method: 'delete',
        url: `/segments/${id}`
    }).then((res) => res.data.data);
};

export const addProductsToSegment = (segmentId, asins) => {
    return authHttp({
        data: {
            asins,
            segmentId,
        },
        method: 'post',
        url: '/segment-products'
    }).then((res) => res.data.data);
};

export const updateProduct = (id, segmentId) => {
    return authHttp({
        data: {
            segmentId
        },
        method: 'patch',
        url: `/segment-products/${id}`
    }).then((res) => res.data.data);
};

export const deleteProduct = (id) => {
    return authHttp({
        method: 'delete',
        url: `/segment-products/${id}`
    }).then((res) => res.data.data);
};
